import {
  pricingCalculatorIntegrationsHash,
  usePricingCalculatorIntegrationsMultiSelector,
} from '../hooks/usePricingCalculatorIntegrationsMultiSelector';
import { FC } from 'react';
import {
  FormControl,
  InputLabel,
  Select,
  Input,
  MenuItem,
  Checkbox,
  ListItemText,
  Tooltip,
  IconButton,
} from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

/**
 * PricingCalculatorIntegrationsMultiSelector
 *
 * Multi-select dropdown for selecting integrations in the pricing calculator.
 * Includes info icons linking to product documentation pages.
 */
export const PricingCalculatorIntegrationsMultiSelector: FC<
  ReturnType<typeof usePricingCalculatorIntegrationsMultiSelector>
> = (props) => {
  const selectedItemsSet = new Set(props.selectedIntegrations);

  const renderSelectedItems = () => {
    return props.selectedIntegrations
      .map((value) => {
        const item = pricingCalculatorIntegrationsHash[value];
        return item ? item.name : value;
      })
      .join(', ');
  };

  return (
    <FormControl className="filter-fields" fullWidth>
      <InputLabel id="multi-select-integrations">Select Integrations</InputLabel>
      <Select
        labelId="multi-select-integrations"
        multiple
        value={props.selectedIntegrations}
        onChange={(e) => props.onSelectIntegration(e.target.value as string[])}
        input={<Input />}
        renderValue={renderSelectedItems}
        MenuProps={{
          anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
          transformOrigin: { vertical: 'top', horizontal: 'left' },
          style: { maxHeight: 300 },
        }}
      >
        {props.integrationItems.map((value) => {
          const item = pricingCalculatorIntegrationsHash[value];
          const label = item ? item.name : value;
          const url = item?.url;

          return (
            <MenuItem key={value} value={value}>
              <Checkbox checked={selectedItemsSet.has(value)} />
              <ListItemText primary={label} />
              {url && (
                <Tooltip title="Click to view integration info">
                  <IconButton
                    size="small"
                    aria-label={`View docs for ${label}`}
                    onClick={(e) => {
                      e.stopPropagation();
                      window.open(url, '_blank', 'noopener,noreferrer');
                    }}
                    sx={{ ml: 1 }}
                  >
                    <InfoOutlinedIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
              )}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
};
